exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /dist/src/app/user/reset-password/new-password/new-password.component.scss
// module id = ../../../../../src/app/user/reset-password/new-password/new-password.component.scss
// module chunks = main